import { useAuth } from '@clerk/clerk-react';
import useSWR from 'swr';
import { useUtcDay } from '@/hooks/useUtcDay';
import { spacesApi } from '@/lib/api';
import { VOLATILE_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

// `period` is a yyyy-MM key; null skips the read (a trip has no month to ask about). The API derives each status
// against its own UTC day, so the day is part of the key: a tab left open across midnight reads again instead of
// showing yesterday's "a vencer" next to today's dates (the count, the groups and the pills all come from one read).
export function useSpaceCommitments(spaceId: string, period: string | null) {
  const { userId } = useAuth();
  const fetch = useAuthedFetcher();
  const today = useUtcDay();
  return useSWR(userId && period ? ['space-commitments', userId, spaceId, period, today] : null,
    () => fetch((token) => spacesApi.commitments(token, spaceId, period!)),
    { ...VOLATILE_SWR_OPTIONS, shouldRetryOnError: false });
}
